import baseURL from './url';

let usuario = null;

export const fetchUsuario = async () => {
    try {
        const response = await fetch(`${baseURL}/userLogued.php`, {
            method: 'GET',
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        
        // Normalizar arrays - asegurar que siempre sean arrays
        if (!Array.isArray(data.categorias)) {
            data.categorias = data.categorias || [];
        }
        if (!Array.isArray(data.servicios)) {
            data.servicios = data.servicios || [];
        }
        
        // Normalizar idCategorias e idServicios
        if (!Array.isArray(data.idCategorias)) {
            if (data.idCategorias && typeof data.idCategorias === 'string') {
                data.idCategorias = data.idCategorias.split(',').map(id => parseInt(id));
            } else if (data.idCategoria) {
                data.idCategorias = [parseInt(data.idCategoria)];
            } else {
                data.idCategorias = data.categorias.map(c => parseInt(c.idCategoria));
            }
        }
        
        if (!Array.isArray(data.idServicios)) {
            if (data.idServicios && typeof data.idServicios === 'string') {
                data.idServicios = data.idServicios.split(',').map(id => parseInt(id));
            } else if (data.idServicio) {
                data.idServicios = [parseInt(data.idServicio)];
            } else {
                data.idServicios = data.servicios.map(s => parseInt(s.idServicio));
            }
        }
        
        // Helper: obtener Ceseco principal
        data.getCesecoPrincipal = () => {
            return data.cesecoPrincipal || 
                   data.categorias.find(c => c.esPrincipal === 1 || c.esPrincipal === '1') ||
                   (data.categorias.length > 0 ? data.categorias[0] : null);
        };
        
        // Helper: obtener Servicio principal
        data.getServicioPrincipal = () => {
            return data.servicioPrincipal || 
                   data.servicios.find(s => s.esPrincipal === 1 || s.esPrincipal === '1') ||
                   (data.servicios.length > 0 ? data.servicios[0] : null);
        };
        
        // Helper: verificar si tiene acceso a un Ceseco
        data.tieneAccesoACeseco = (idCategoria) => {
            if (['admin', 'direccion'].includes(data.rol)) return true;
            const idCat = parseInt(idCategoria);
            return data.idCategorias && data.idCategorias.includes(idCat);
        };
        
        // Helper: verificar si tiene acceso a un Servicio
        data.tieneAccesoAServicio = (idServicio) => {
            if (['admin', 'direccion'].includes(data.rol)) return true;
            const idServ = parseInt(idServicio);
            return data.idServicios && data.idServicios.includes(idServ);
        };
        
        // Helper: obtener todos los Cesecos asignados (nombres)
        data.getCesecosAsignados = () => {
            return data.categorias.map(c => c.categoria);
        };
        
        // Helper: obtener todos los Servicios asignados (títulos)
        data.getServiciosAsignados = () => {
            return data.servicios.map(s => s.titulo);
        };
        
        usuario = data;
    } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
        usuario = null;
    }
};

export const getUsuario = () => {
    if(baseURL.includes('localhost')) {
        return {
            idUsuario: 1,
            nombre: 'Administrador de prueba',
            email: 'admin@prueba.com',
            rol: 'admin',
            idCategoria: 1,
            idCategorias: [1, 2],
            categorias: [
                {idCategoria: 1, categoria: 'CESECO NORTE', esPrincipal: 1, orden: 2},
                {idCategoria: 2, categoria: 'CESECO SUR', esPrincipal: 0, orden: 1}
            ],
            cesecoPrincipal: {idCategoria: 1, categoria: 'CESECO NORTE', esPrincipal: 1},
            idServicio: 1,
            idServicios: [1, 3],
            servicios: [
                {idServicio: 1, titulo: 'Programa 1', esPrincipal: 1, idCategoriaServicio: 1, categoriaServicio: 'CESECO NORTE'},
                {idServicio: 3, titulo: 'Programa 2', esPrincipal: 0, idCategoriaServicio: 2, categoriaServicio: 'CESECO SUR'}
            ],
            servicioPrincipal: {idServicio: 1, titulo: 'Programa 1', esPrincipal: 1},
            telefono: '1234567890',
            estatus: 'activo',
            // Helpers
            getCesecoPrincipal: function() { return this.cesecoPrincipal || this.categorias[0]; },
            getServicioPrincipal: function() { return this.servicioPrincipal || this.servicios[0]; },
            tieneAccesoACeseco: function(id) { return ['admin', 'direccion'].includes(this.rol) || this.idCategorias.includes(parseInt(id)); },
            tieneAccesoAServicio: function(id) { return ['admin', 'direccion'].includes(this.rol) || this.idServicios.includes(parseInt(id)); },
            getCesecosAsignados: function() { return this.categorias.map(c => c.categoria); },
            getServiciosAsignados: function() { return this.servicios.map(s => s.titulo); }
        };
    }
    return usuario;
};
